import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import ChangeRealization from "./components/changeRealization";
import ChangeOffert from "./components/changeOffer"; // Musisz stworzyć ten komponent podobny do ChangeRealization
import ChangeReference from "./components/ChangeReference"; // Musisz stworzyć
import ChangePartner from "./components/changePartner"; 
import MediaLibrary from "./components/MediaLibrary";
export default function MainPage() {
const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mediaLibraryOpen, setMediaLibraryOpen] = useState(false);
  const [targetField, setTargetField] = useState(null);
  const [desc, setDesc] = useState('');
  const [realIds, setRealIds] = useState([]);
  const [offertIds, setOffertIds] = useState([]);
  const [refIds, setRefIds] = useState([]); // Stan dla referencji
  const [partnerIds, setPartnerIds] = useState([]); // Stan dla partnerów

  const [selectedIndex, setSelectedIndex] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [offertModalOpen, setOffertModalOpen] = useState(false);
  const [refModalOpen, setRefModalOpen] = useState(false);
  const [partnerModalOpen, setPartnerModalOpen] = useState(false);

  const openMediaLibrary = (field) => {
    setTargetField(field);
    setMediaLibraryOpen(true);
  };

  const loadData = useCallback(async () => {
    try {
      const response = await axios.get('https://megamont.pl/api/mainpage');
      setData(response.data);
      setDesc(response.data.description || "");
      
      const parseJson = (val) => typeof val === 'string' ? JSON.parse(val || "[]") : (val || []);
      
      setRealIds(parseJson(response.data.realizacje));
      setOffertIds(parseJson(response.data.oferta));
      setRefIds(parseJson(response.data.referencje)); // Zakładam kolumnę referencje w tabeli main
      setPartnerIds(parseJson(response.data.partnerzy)); // Zakładam kolumnę partnerzy w tabeli main
      
      setLoading(false);
    } catch (error) {
      console.error('Błąd ładowania danych:', error);
      setLoading(false);
    }
  }, []); 

  useEffect(() => { loadData(); }, [loadData]);

  // Funkcja uniwersalna do zapisu MainPage
const updateMainPage = async (newDesc, newReals, newOfferts, newRefs, newPartners) => {
    try {
      await axios.put('https://megamont.pl/api/mainpage', {
        description: newDesc,
        realizacje: newReals,
        oferta: newOfferts,
        referencje: newRefs,
        partnerzy: newPartners 
      });
      loadData();
    } catch (err) {
      console.error(err);
      alert("Błąd podczas zapisywania zmian.");
    }
};

  const handleSaveTexts = () => updateMainPage(desc, realIds, offertIds);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('image', file);
    try {
      await axios.put('https://megamont.pl/api/mainpage/image', formData);
      alert("Zdjęcie zmienione!");
      loadData();
    } catch (err) { console.error("Błąd przesyłania zdjęcia"); }
  };

  // Wybór Realizacji (Max 3)
  const onRealizationSelect = async (selectedReal) => {
    let currentIds = [...realIds];
    while (currentIds.length < 3) currentIds.push(null);
    currentIds[selectedIndex] = selectedReal.id;
    
    await updateMainPage(desc, currentIds, offertIds);
    setModalOpen(false);
  };

  // Wybór Oferty (Max 6)
  const onOffertSelect = async (selectedOff) => {
    let currentIds = [...offertIds];
    while (currentIds.length < 6) currentIds.push(null);
    currentIds[selectedIndex] = selectedOff.id;
    
    await updateMainPage(desc, realIds, currentIds);
    setOffertModalOpen(false);
  };
  const onReferenceSelect = async (selectedRef) => {
    let currentIds = [...refIds];
    while (currentIds.length < 4) currentIds.push(null);
    currentIds[selectedIndex] = selectedRef.id;
    await updateMainPage(desc, realIds, offertIds, currentIds, partnerIds);
    setRefModalOpen(false);
  };

  // Dodawanie Partnera (Nielimitowane)
  const onPartnerSelect = async (selectedPart) => {
    // 1. Natychmiast zamykamy modal (usuwamy go z DOM, zanim cokolwiek innego się wydarzy)
    setPartnerModalOpen(false);

    // 2. Przygotowujemy dane (partnerIds to stan, więc robimy kopię)
    const currentIds = [...partnerIds, selectedPart.id];

    // 3. Wykonujemy operację z lekkim opóźnieniem (pozwalamy Reactowi odmontować modal)
    setTimeout(async () => {
      try {
        await axios.put('https://megamont.pl/api/mainpage', {
          description: desc,
          realizacje: realIds,
          oferta: offertIds,
          referencje: refIds,
          partnerzy: currentIds
        });
        
        // 4. Dopiero na samym końcu ładujemy nowe dane
        loadData();
      } catch (err) {
        console.error("Błąd zapisu partnera:", err);
        alert("Błąd podczas zapisywania partnera w bazie.");
      }
    }, 150); // 150ms to bezpieczny czas dla Reacta na "posprzątanie" DOM
  };
  const removePartner = async (idToRemove) => {
    const currentIds = partnerIds.filter(id => id !== idToRemove);
    await updateMainPage(desc, realIds, offertIds, refIds, currentIds);
  };
  const handleHeroUpload = async (e) => {
      const file = e.target.files[0];
      if (!file) return;
      const formData = new FormData();
      formData.append('image', file);
      try {
          await axios.put('https://megamont.pl/api/mainpage/hero', formData);
          alert("Zdjęcie startowe (Hero) zmienione!");
          loadData();
      } catch (err) { 
          console.error("Błąd przesyłania zdjęcia hero"); 
          alert("Błąd podczas wgrywania zdjęcia hero.");
      }
  };
  const handleSelectFromServer = async (fileName) => {
    try {
      // Przygotowujemy obiekt do aktualizacji
      const updatePayload = {};
      updatePayload[targetField] = fileName; // dynamicznie hero: fileName lub image: fileName

      await axios.put('https://megamont.pl/api/mainpage', updatePayload);
      
      alert("Zaktualizowano zdjęcie!");
      setMediaLibraryOpen(false);
      loadData();
    } catch (err) {
      console.error("Błąd podczas wyboru zdjęcia", err);
    }
  };
  if (loading) return <div className="p-5 text-center">Ładowanie panelu...</div>;

  return (
    <div className='main p-4'> 
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="m-0 text-uppercase fw-bold">Zarządzanie Stroną Główną</h2>
        <button className="btn btn-success fw-bold px-4 shadow-sm" onClick={handleSaveTexts}>
          ZAPISZ OPIS
        </button>
      </div>
     {/* Sekcja Hero */}
     <div className="card shadow-sm p-4 mb-4 border-0">
        <h4 className="mb-3 border-bottom pb-2">Zdjęcie startowe</h4>
        <div className="row mt-3">
            <div className="col-12 text-center">
              <label className="fw-bold mb-2">Aktualne zdjęcie w tle (Hero):</label>
              {data?.hero ? (
                  <img 
                    src={`https://megamont.pl/uploads/${data.hero}`} 
                    alt="Hero" 
                    className="img-thumbnail d-block mx-auto my-2 border-0 shadow-sm" 
                    style={{ maxHeight: '700px', width: '100%', objectFit: 'cover' }} 
                  />
              ) : (
                  <div className="alert alert-secondary">Brak wgranego zdjęcia hero</div>
              )}
              
              <div className="d-flex gap-2 justify-content-center mt-2">
              <label htmlFor="heroImg" className="btn btn-primary">
                <i className="fas fa-upload me-2"></i>Wgraj nowe
              </label>
              <button className="btn btn-outline-dark" onClick={() => openMediaLibrary('hero')}>
                <i className="fas fa-images me-2"></i>Wybierz z serwera
              </button>
            </div>
            </div>
        </div>
      </div>
     

      {/* Na samym końcu przed zamknięciem głównego diva */}
      {mediaLibraryOpen && (
        <MediaLibrary 
          onSelect={handleSelectFromServer} 
          onClose={() => setMediaLibraryOpen(false)} 
        />
      )}
      {/* SEKCJA O NAS */}
      <div className="card shadow-sm p-4 mb-4 border-0">
        <h4 className="mb-3 border-bottom pb-2">Sekcja O nas</h4>
        <div className="row mt-3">
          <div className="col-md-7">
            <label className="fw-bold mb-2">Opis na stronie:</label>
            <textarea className="form-control shadow-none" rows="6" value={desc} onChange={(e) => setDesc(e.target.value)} />
          </div>
          <div className="col-md-5 text-center border-start">
            <label className="fw-bold mb-2">Aktualne zdjęcie:</label>
            <img src={`https://megamont.pl/uploads/${data?.image}`} alt="O nas" className="img-thumbnail d-block mx-auto my-2 border-0 shadow-sm" style={{ maxHeight: '180px', width: 'auto' }} />
            <input type="file" id="mainImg" hidden onChange={handleImageUpload} accept="image/*" />
            <label htmlFor="mainImg" className="btn btn-outline-primary w-100 mt-2" style={{cursor: 'pointer'}}>Wgraj nowe zdjęcie</label>
          </div>
        </div>
      </div>

      {/* SEKCJA OFERT  */}
      <section className="Offert mt-4" style={{background:"none"}}>
        <div className="content">
          <h1 style={{color:"#000"}}>Sekcja Ofert</h1>
          <div className="row">
            {[0, 1, 2, 3, 4, 5].map((idx) => {
              const offer = data?.offers?.[idx];
              return (
                <div className="col-xl-4 mb-3" key={`off-slot-${idx}`}>
                  <div className="card shadow-sm border-0 p-3 text-center h-100 d-flex flex-column justify-content-center">
                    {offer ? (
                      <div className="offerContent">
                        <i className="fas fa-building fa-2x mb-2 text-primary"></i>
                        <h5 className="fw-bold d-block mb-3">{offer.name}</h5>
                        <button className="btn btn-custom btn-sm btn-outline-secondary w-100" onClick={() => { setSelectedIndex(idx); setOffertModalOpen(true); }}>
                          Zamień Ofertę
                        </button>
                      </div>
                    ) : (
                      <div className="emptySlot py-4">
                        <p className="text-muted small">Miejsce na ofertę #{idx + 1}</p>
                        <button className="btn btn-sm btn-primary" onClick={() => { setSelectedIndex(idx); setOffertModalOpen(true); }}>
                          Dodaj Ofertę
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* SEKCJA REALIZACJI (Max 3) */}
      <section className="Realizations mt-5">
        <h4 className="mb-4 border-bottom pb-2">Podgląd Realizacji na Stronie Głównej</h4>
        <div className="row">
          {[0, 1, 2].map((idx) => {
            const real = data?.realizations?.[idx];
            let firstImage = "";
            try {
              if (real && real.images) {
                const imgArray = typeof real.images === 'string' ? JSON.parse(real.images) : real.images;
                firstImage = imgArray[0];
              }
            } catch (e) { console.error("Błąd parsowania zdjęć", e); }

            return (
              <div className="col-xl-4 mb-4" key={`real-slot-${idx}`}>
                <div className="card h-100 shadow-sm border-0">
                  {real ? (
                    <>
                      <img src={`https://megamont.pl/uploads/realizacja_${real.id}/${firstImage}`} className="card-img-top" alt={real.name} style={{ height: '220px', objectFit: 'cover' }} />
                      <div className="card-body d-flex flex-column">
                        <h5 className="card-title fw-bold text-primary">{real.name}</h5>
                        <p className="card-text small text-muted flex-grow-1">{real.description?.substring(0, 120)}...</p>
                        <div className="d-flex justify-content-between align-items-center border-top pt-3 mt-2">
                          <div className="small text-muted d-flex gap-2">
                            <span><i className="bi bi-geo-alt"></i> {real.location || "Polska"}</span>
                            <span><i className="bi bi-calendar"></i> {real.start_at && new Date(real.start_at).toLocaleDateString('pl-PL')}</span>
                          </div>
                          <button className="btn btn-sm btn-outline-primary px-3" onClick={() => { setSelectedIndex(idx); setModalOpen(true); }}>Zamień</button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="card-body d-flex flex-column align-items-center justify-content-center p-5 text-muted bg-light rounded" style={{minHeight: '350px', border: '2px dashed #ccc'}}>
                      <p className="fw-bold text-uppercase small">Wolny slot realizacji</p>
                      <button className="btn btn-sm btn-primary" onClick={() => { setSelectedIndex(idx); setModalOpen(true); }}>Wybierz realizację</button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </section>
        
   {/* SEKCJA REFERENCJI (Max 4) */}
      <section className="References mt-5" style={{background:"none"}}>
        <div className="content" style={{background:"none"}}>
            <h1 style={{color:"#000"}}>Zarządzanie Referencjami</h1>
            <div className="container mt-4">
                <div className="row">
                    {[0, 1, 2, 3].map((idx) => {
                        const ref = data?.references?.[idx];
                        return (
                            <div className="col-xl-3 col-md-6 mb-4" key={`ref-slot-${idx}`}>
                                <div className="card shadow-sm border-0 p-2 text-center h-100 w-100">
                                    {ref ? (
                                        <>
                                            <img className='img-fluid rounded w-100' src={`https://megamont.pl/uploads/references/${ref.name}`} alt="" style={{height: '200px', objectFit: 'contain'}} />
                                            <button className="btn btn-sm btn-outline-danger mt-2" onClick={() => {
                                                const newRefs = [...refIds];
                                                newRefs[idx] = null;
                                                updateMainPage(desc, realIds, offertIds, newRefs, partnerIds);
                                            }}>Usuń</button>
                                            <button className="btn btn-sm btn-custom mt-1" onClick={() => { setSelectedIndex(idx); setRefModalOpen(true); }}>Zmień</button>
                                        </>
                                    ) : (
                                        <div className="d-flex flex-column align-items-center justify-content-center h-100 border rounded py-5 bg-light">
                                            <p className="text-muted small">Miejsce na referencję #{idx + 1}</p>
                                            <button className="btn btn-sm btn-success" onClick={() => { setSelectedIndex(idx); setRefModalOpen(true); }}>Dodaj</button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
      </section>

      {/* SEKCJA PARTNERZY (Dynamiczna) */}
      <section className="Partners mt-5 border-top pt-4">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-4">
              <h1 className="m-0">Nasi Partnerzy</h1>
              <button className="btn btn-primary" onClick={() => setPartnerModalOpen(true)}>
                  <i className="fas fa-plus"></i> Dodaj nowego partnera
              </button>
          </div>
          
          <div className="row align-items-stretch">
              {data?.partners?.length > 0 ? (
                  data.partners.map((partner) => (
                      <div className="col-xl-2 col-md-3 col-6 mb-4" key={`partner-item-${partner.id}`}>
                          <div className="card p-3 shadow-sm border-0 h-100 text-center position-relative">
                              <div className="d-flex align-items-center justify-content-center" style={{ height: '80px' }}>
                                  <img 
                                      src={`https://megamont.pl/uploads/partners/${partner.name}`} 
                                      className="img-fluid" 
                                      alt={partner.name} 
                                      style={{ maxHeight: '100%', objectFit: 'contain' }}
                                  />
                              </div>
                              <button 
                                  className="btn btn-danger btn-sm mt-3 w-100" 
                                  onClick={() => removePartner(partner.id)}
                              >
                                  Usuń
                              </button>
                          </div>
                      </div>
                  ))
              ) : (
                  <div className="col-12 text-center py-4 bg-light rounded border-dashed">
                      <p className="text-muted m-0">Nie wybrano jeszcze żadnych partnerów do wyświetlenia.</p>
                  </div>
              )}
          </div>
        </div>
      </section>

      {/* MODALE */}
      {modalOpen && <ChangeRealization onClose={() => setModalOpen(false)} onSelect={onRealizationSelect} />}
      {offertModalOpen && <ChangeOffert onClose={() => setOffertModalOpen(false)} onSelect={onOffertSelect} />}
      {refModalOpen && <ChangeReference onClose={() => setRefModalOpen(false)} onSelect={onReferenceSelect} />}
      {partnerModalOpen && <ChangePartner onClose={() => setPartnerModalOpen(false)} onSelect={onPartnerSelect} />}
      {/* DEBUG */}
      <div className="mt-4 p-3 bg-dark text-white rounded small shadow-sm d-flex flex-column gap-1">
        <span><strong>Realizacje (JSON):</strong> {JSON.stringify(realIds)}</span>
        <span><strong>Oferty (JSON):</strong> {JSON.stringify(offertIds)}</span>
      </div>
    </div>
  );
}